import React from 'react';
import { IHeadlineProps } from './Headline.types';

const Headline = ({
  title,
  subtitle,
  metaText,
  onMoveDepartmentEntryUp,
  onMoveDepartmentEntryDown,
}: IHeadlineProps) => {
  return (
    <div key={title} className="headline">
      <div className="headlineText">
        <h3>{title}</h3>
        <h3>{subtitle}</h3>
      </div>
      <div className="metaText">
        <p style={{ paddingRight: '1rem' }}>{metaText}</p>
        {onMoveDepartmentEntryUp && <button onClick={onMoveDepartmentEntryUp}>↑</button>}
        {onMoveDepartmentEntryDown && <button onClick={onMoveDepartmentEntryDown}>↓</button>}
      </div>
    </div>
  );
};

export default Headline;
